import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $addPadding?: boolean }>`
    width: 100%;
    height: 100vh;
    height: 100dvh;

    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        position: sticky;
        top: 0;
        right: 0;
        z-index: 10;
        width: 500px;
        flex-shrink: 0;

        ${({ $addPadding }) =>
            $addPadding &&
            css`
                padding: 20px 20px 20px 0;
                flex-shrink: 1;
                width: unset;
            `}
    }
`;
